(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shinigami-leave-review"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-shini-leave-review]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    const destination = new URL(window.location.href);
    destination.searchParams.set('write_review', '1');
    destination.hash = 'judgeme';

    if (destination.search === window.location.search) {
      window.location.hash = 'judgeme';
      window.location.reload();
    } else {
      window.location.assign(destination.href);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
